import {TimeZoneShift} from '../types';

export function correctTimeStamp(timestamp: UnixTimeStamp, shift: TimeZoneShift): UnixTimeStamp {
  return timestamp - shift;
}
